import React, { useState, useCallback, useMemo } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { MdClose } from "react-icons/md";
import { NumericFormat } from "react-number-format";
import { numberFormat } from "../../helper";
import { errorSwal } from "../../helper/sweetalert";
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from "../../const";

function DragDrop({ 
  handleOnDragEnd, 
  reorder, 
  onRemoveItem, 
  cartDatas, 
  activeCart, 
  setCartDatas, 
  updateOrder, 
  shopData 
}) {
  const [isFreeStatus, setIsFreeStatus] = useState({
    isOpen: false,
    preOrder: null,
    cartIndex: null,
  });

  // Memoized handler to prevent unnecessary re-renders
  const handleEditPriceProduct = useCallback((e, index) => {
    const _priceValue = e?.target?.value;
    const _price = parseFloat(_priceValue.replace(/,/g, '')) || 0;

    setCartDatas(prevCartDatas => 
      prevCartDatas.map(cart => 
        cart?.label === activeCart 
          ? {
              ...cart,
              data: {
                ...cart.data,
                orders: cart.data.orders.map((order, orderIndex) => 
                  orderIndex === index 
                    ? {
                        ...order,
                        price: _price,
                        totalPrice: order.amount * _price
                      }
                    : order
                )
              }
            }
          : cart
      )
    );
  }, [activeCart, setCartDatas]);

  const handleEditOrderNote = useCallback((e, index) => {
    const note = e?.target?.value ?? "";

    setCartDatas(prevCartDatas =>
      prevCartDatas.map(cart =>
        cart?.label === activeCart
          ? {
              ...cart,
              data: {
                ...cart.data,
                orders: cart.data.orders.map((order, orderIndex) =>
                  orderIndex === index
                    ? {
                        ...order,
                        note,
                      }
                    : order
                )
              }
            }
          : cart
      )
    );
  }, [activeCart, setCartDatas]);

  console.log("offerprice cartDatas: ", cartDatas)

  // Optimized free item addition handler
  const handleAddAmountFree = useCallback((e) => {
    e.preventDefault();
    
    const { cartIndex, preOrder } = isFreeStatus;
    console.log("isFreeStatus: ", preOrder)
    const orderIndex = preOrder?.index;
    let _amountFree = parseInt(preOrder?.item?.amountFree);
    
    console.log("type of_ value: ", typeof(_amountFree))
    if (orderIndex === undefined || orderIndex < 0) {
      errorSwal('ເກີດຂໍ້ຜິດພາດ: ບໍ່ສາມາດເພີ່ມຈຳນວນແຖມໄດ້');
      return;
    }

    setCartDatas(prevCart => 
      prevCart?.map(cart => 
        cart?.product === cartIndex
          ? {
              ...cart,
              data: {
                ...cart?.data,
                orders: cart?.data?.orders?.map((order, index) => 
                  index === orderIndex
                    ? { ...order, amountFree: _amountFree }
                    : order
                )
              }
            }
          : cart
      )
    );

    // Close the modal
    setIsFreeStatus({ isOpen: false, preOrder: null, cartIndex: null });
  }, [isFreeStatus, setCartDatas]);

  // Memoized modal close handler
  const onCloseFreeStatus = useCallback(() => {
    setIsFreeStatus({ isOpen: false, preOrder: null, cartIndex: null });
  }, []);

  // Memoized order amount change handler
  const handleOrderAmountChange = useCallback((e, item) => {
    const value = parseInt(e?.target?.value, 10);
    const isLessStocks = shopData?.shop?.isLessStocks;

    if (value < 0) {
      errorSwal('ຈຳນວນສີນຄ້າຕ້ອງ ຫລາຍກ່ອນ 0 ເດີ້');
      return;
    }

    if (!isLessStocks && value > item?.totalAmount) {
      errorSwal('ຈຳນວນສີນຄ້າຕ້ອງ ບໍ່ເກີນຈຳນວນໃນສະຕ໋ອກ');
      return;
    }

    updateOrder({
      product: item,
      productId: item?.product,
      isAdded: false,
      changeValue: value,
    });
  }, [shopData, updateOrder]);

  // Render empty state if no items
  if (!reorder || reorder.length <= 0) {
    return (
      <div className="d-flex justify-content-center align-items-center py-4">
        <h3>ຍັງບໍ່ມີສິນຄ້າໃນກະຕ່າ!</h3>
      </div>
    );
  }

  return (
    <>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="reorder">
          {(provided) => (
            <ul {...provided.droppableProps} ref={provided.innerRef}>
              {reorder.map((item, index) => (
                <Draggable
                  key={item?.product}
                  draggableId={item?.product}
                  index={index}
                >
                  {(provided) => (
                    <div
                      className="reorder-card-items"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <div className="d-flex flex-column" style={{ lineHeight: ".7em" }}>
                        <p>
                          {index + 1}. {item?.productName}
                        </p>
                        <small 
                          className="text-muted pl-4" 
                          style={{ fontSize: 12, marginTop: 4 }}
                        >
                          ລວມເງິນ {numberFormat(item?.price * item?.amount)} {item?.currency}
                        </small>
                      </div>

                      <div
                        className="card-action-item"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <NumericFormat
                          name="price"
                          min={0}
                          className="form-control"
                          style={{ width: 105, fontSize: 13 }}
                          onChange={(e) => handleEditPriceProduct(e, index)}
                          defaultValue={item?.price}
                          thousandSeparator={true}
                        />
                        <Form.Control
                          max={item?.totalAmount}
                          style={{
                            width: 60,
                            textAlign: "center",
                            borderRadius: 5,
                          }}
                          name="amount"
                          type="text"
                          onChange={(e) => handleOrderAmountChange(e, item)}
                          value={item?.amount}
                        />
                        <Form.Control
                          name="note"
                          type="text"
                          placeholder="ໝາຍເຫດ..."
                          style={{ width: 160, fontSize: 12 }}
                          onChange={(e) => handleEditOrderNote(e, index)}
                          value={item?.note || ""}
                        />
                        {/* <Button 
                          onClick={() => 
                            setIsFreeStatus({ 
                              isOpen: true, 
                              preOrder: { item, index }, 
                              cartIndex: item?.product 
                            })
                          } 
                          variant="success" 
                          style={{ maxHeight: 40, minWidth: 80, fontSize: 12 }}
                        >
                          ແຖມ: {item?.amountFree || 0}
                        </Button> */}
                        <div
                          className="remove-reorder-item"
                          onClick={() => onRemoveItem(item)}
                        >
                          <MdClose />
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>

      <Modal centered show={isFreeStatus?.isOpen} onHide={onCloseFreeStatus}>
        <Modal.Header closeButton>
          <Modal.Title>{isFreeStatus?.preOrder?.item?.productName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleAddAmountFree}>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>ຈຳນວນ</Form.Label>
                  <Form.Control 
                    readOnly 
                    disabled 
                    type="text" 
                    value={isFreeStatus?.preOrder?.item?.amount} 
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>ແຖມ</Form.Label>
                  <Form.Control 
                    autoFocus 
                    type="text"
                    placeholder="..."
                    value={isFreeStatus?.preOrder?.item?.amountFree || ''}
                    onChange={(e) => 
                      setIsFreeStatus(prev => ({
                        ...prev,
                        preOrder: {
                          ...prev.preOrder,
                          item: {
                            ...prev.preOrder?.item,
                            amountFree: e?.target?.value
                          }
                        }
                      }))
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex gap-2 justify-content-end align-items-center mt-4">
              <Button type="button" variant="light" onClick={onCloseFreeStatus}>
                ຍົກເລີກ
              </Button>
              <Button 
                type="submit" 
                variant="light" 
                style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE }}
              >
                ຢືນຢັນ
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default React.memo(DragDrop);
